module.exports = __webpack_public_path__ + "img/accordion-mask-elastic-hero.6aef492f.jpg";